export const LEADER_BOARD_DEFAULT_LIMIT = 20;
